 <div *ngIf="!basica && router.url === '/cliente/instalaciones'">
  
  <app-nav-bar-cliente></app-nav-bar-cliente>
</div>
 <div *ngIf="router.url === '/cliente/contratistas'">
  
  <app-nav-bar-cliente></app-nav-bar-cliente>
</div>
<div *ngIf="router.url === '/cliente/centros'">

  <app-nav-bar-cliente></app-nav-bar-cliente>
</div>
<div *ngIf="router.url === '/cliente/gestores'">

  <app-nav-bar-cliente></app-nav-bar-cliente>
</div>
<div *ngIf="router.url === '/cliente/transportista'">
 
  <app-nav-bar-cliente></app-nav-bar-cliente>
</div>
<div *ngIf="router.url === '/cliente/estado'">
  <h1>Entidad / Estado</h1>
</div>
<div *ngIf="router.url === '/cliente/perfil'">
  <h1>Perfil Cliente</h1>
</div>
<div *ngIf="router.url === '/cliente/zonasgrupos'">
  <h1>Zonas y Agrupaciones</h1>
</div>
<div *ngIf="router.url === '/cliente/gestion'">
  <h1>Gestión Contratistas</h1>
</div>
